export default __webpack_public_path__ + "static/media/drone.86b7acf4.svg";